import {
  getPolicies,
  newPolicy,
  updatePolicy,
  deletePolicy,
  checkUserPolicy
} from '@/api/api.js';

export const state = {
  headers: [
    {
      text: 'Policy ID',
      align: 'start',
      sortable: false,
      value: 'policy_id'
    },
    { text: 'Policy Name', value: 'policy_name' },
    { text: 'Policy Description', value: 'policy_description' },
    { text: 'Quota Metric', value: 'quota_metric' },
    { text: 'Quota Period', value: 'quota_period' },
    { text: 'Quota Limit', value: 'quota_limit' },
    { text: 'Max Calls/Day', value: 'max_calls_per_day' },
    { text: 'Actions', value: 'actions', sortable: false, width: 130 }
  ],
  policies: [],
  blankPolicy: {
    policy_id: '',
    policy_name: '',
    policy_description: '',
    quota_metric: 'calls',
    quota_period: 'monthly',
    quota_limit: null,
    max_calls_per_day: null
  },
  isModifingPolicy: null,
  policy_id: ''
};

export const mutations = {
  GET_POLICIES(state, policiesArray) {
    state.policies = policiesArray;
  },
  NEW_POLICY(state, policyToAdd) {
    state.policies.push(policyToAdd.data.createPolicy);
    state.blankPolicy = policyToAdd.data.createPolicy;
  },
  UPDATE_POLICY(state, policy) {
    state.policies.forEach(element => {
      if (element.policy_id == policy.data.updatePolicy.policy_id) {
        element.policy_name = policy.data.updatePolicy.policy_name;
        element.policy_description =
          policy.data.updatePolicy.policy_description;
        element.quota_metric = policy.data.updatePolicy.quota_metric;
        element.quota_period = policy.data.updatePolicy.quota_period;
        element.quota_limit = policy.data.updatePolicy.quota_limit;
        element.max_calls_per_day =
          policy.data.updatePolicy.max_calls_per_day;
      }
    });

    state.blankPolicy = policy.data.updatePolicy;
  },
  UPDATE_APP_POLICY(state, policy) {
    state.policies.forEach(element => {
      if (element.policy_id == policy.policy_id) {
        element.policy_name = policy.policy_name;
        element.policy_description = policy.policy_description;
      }
    });

    state.blankPolicy = policy.data.createPolicy;
  },
  DELETE_POLICY(state, delete_policy_id) {
    state.policies.forEach(element => {
      if (element.policy_id == delete_policy_id) {
        const index = state.policies.indexOf(element);
        state.policies.splice(index, 1);
      }
    });
  },
  SWITCH_IS_MODIFING_POLICY(state, data) {
    state.isModifingPolicy = data;
  }
};

export const actions = {
  storeIsModifingPolicy({ commit }, data) {
    commit('SWITCH_IS_MODIFING_POLICY', data);
  },
  async storePolicies({ dispatch, commit }) {
    try {
      const policiesArray = await getPolicies();
      commit('GET_POLICIES', policiesArray.data.listPolicies);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeIsModifingPolicy',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async storeNewPolicy({ commit, dispatch }, policy) {
    try {
      const policyToAdd = await newPolicy(
        policy.policy_name,
        policy.policy_description,
        policy.quota_metric,
        policy.quota_period,
        policy.quota_limit,
        policy.max_calls_per_day
      );
      commit('NEW_POLICY', policyToAdd);
      dispatch('storeIsModifingPolicy', true);
      dispatch('storeCustomerCRMID', policyToAdd.data.createPolicy, {
        root: true
      });
      dispatch(
        'storeToastMessage',
        {
          text: 'policy created',
          type: 'success'
        },
        { root: true }
      );
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeNewPolicy',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async storeUpdatedPolicy({ dispatch, commit }, policy) {
    try {
      const policyToUpdate = await updatePolicy(
        policy.policy_id,
        policy.policy_name,
        policy.policy_description,
        policy.quota_metric,
        policy.quota_period,
        policy.quota_limit,
        policy.max_calls_per_day
      );
      dispatch(
        'storeToastMessage',
        {
          text: 'policy updated',
          type: 'success'
        },
        { root: true }
      );
      commit('UPDATE_POLICY', policyToUpdate);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeUpdatedPolicy',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async deleteTablePolicy({ dispatch, commit }, policy_id) {
    try {
      const check = await checkUserPolicy(policy_id);

      if (check.data.checkUserPolicy.result) {
        dispatch(
          'storeToastMessage',
          {
            text: 'You can\'t delete a policy attached to an API User',
            type: 'warning'
          },
          { root: true }
        );
      } else {
        const policyToDelete = await deletePolicy(policy_id);
        dispatch(
          'storeToastMessage',
          {
            text: 'policy deleted',
            type: 'success'
          },
          { root: true }
        );
        commit('DELETE_POLICY', policyToDelete.data.deletePolicy.policy_id);
      }
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'deleteTablePolicy',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
